var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsAppIcono(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 98.099,
    height: 98.099,
    viewBox: "0 0 98.099 98.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20b038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60d66a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25686",
    "data-name": "Grupo 25686",
    transform: "translate(-169.961 -125.166)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_52593",
    "data-name": "Rect\\xE1ngulo 52593",
    width: 98.099,
    height: 98.099,
    rx: 49.049,
    transform: "translate(169.961 125.165)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25685",
    "data-name": "Grupo 25685",
    transform: "translate(186.81 139.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69589",
    "data-name": "Trazado 69589",
    d: "M264.345,181.183a32.89,32.89,0,0,1-48.708,28.527l-18.181,5.778,5.926-17.481a32.24,32.24,0,0,1-4.71-16.824,32.838,32.838,0,0,1,65.673,0ZM231.51,153.788A27.53,27.53,0,0,0,203.9,181.183a27.114,27.114,0,0,0,5.258,16.062l-3.448,10.172,10.608-3.37a27.467,27.467,0,1,0,15.19-50.258Zm16.581,34.9c-.2-.333-.74-.533-1.542-.933s-4.765-2.333-5.5-2.6-1.277-.4-1.81.4-2.08,2.6-2.551,3.132-.936.6-1.742.2a22.02,22.02,0,0,1-6.474-3.962,24.284,24.284,0,0,1-4.479-5.531c-.467-.8-.047-1.23.352-1.628.363-.36.806-.933,1.208-1.4a5.482,5.482,0,0,0,.805-1.336,1.45,1.45,0,0,0-.069-1.4c-.2-.4-1.81-4.33-2.483-5.93s-1.338-1.536-1.81-1.536a11.608,11.608,0,0,0-1.337.139,4.547,4.547,0,0,0-2.35,1,8.927,8.927,0,0,0-2.816,6.659c0,3.93,2.882,7.729,3.284,8.259s5.567,8.862,13.75,12.06,8.184,2.13,9.66,2,4.761-1.93,5.433-3.8a6.637,6.637,0,0,0,.472-3.8Zm0,0",
    transform: "translate(-197.456 -148.599)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsAppIcono);
export default __webpack_public_path__ + "static/media/WhatsApp-Icono.6d6eb8385a400e638170fcd09171caaf.svg";
export { ForwardRef as ReactComponent };